export default "__VITE_ASSET__hz09$PdV__"